import React from 'react';
import { Container, Col } from 'reactstrap';
import { useIntl } from 'react-intl';

import { IPage } from '@whitelabel/helpers/types';
import { SITE_NAME } from '../../../helpers/constants';
import {
  StyledFooter,
  StyledSectionLegal,
  StyledCopyright,
  StyledNav,
  StyledNavItem,
  StyledNavLink,
  StyledRow,
  StyledDisclaimerContentBlock,
  StyledIntroWrapper,
} from './styled';
import messages from './messages';

const items = [
  { key: 'terms', messageKey: 'termsLink', path: '/terms' },
  { key: 'privacy-policy', messageKey: 'privacyLink', path: '/privacy-policy' },
];

interface IFooterSlimProps {
  disclaimer?: IPage;
}

const FooterSlim = ({ disclaimer }: IFooterSlimProps): JSX.Element => {
  const intl = useIntl();
  return (
    <StyledFooter id="Footer" data-test-id="FooterSlim">
      {disclaimer && (
        <Container>
          <StyledDisclaimerContentBlock blocks={disclaimer.body} />
        </Container>
      )}

      <StyledSectionLegal data-test-id="FooterSlim-section">
        <Container>
          <StyledRow>
            <Col xs={12} lg={4}>
              <StyledIntroWrapper>
                <StyledCopyright data-test-id="FooterSlim-copyright">
                  {`${String.fromCharCode(169)} ${new Date().getFullYear()} ${SITE_NAME}`}
                </StyledCopyright>
              </StyledIntroWrapper>
            </Col>

            <Col xs={12} lg={8}>
              <StyledNav data-test-id="FooterSlim-nav">
                {items.map(({ key, messageKey, path }) => (
                  <StyledNavItem key={key} data-test-id="FooterSlim-navItem">
                    <StyledNavLink to={`/${intl.locale}${path}`} data-test-id="FooterSlim-navLink">
                      {intl.formatMessage(messages[messageKey as keyof typeof messages])}
                    </StyledNavLink>
                  </StyledNavItem>
                ))}
              </StyledNav>
            </Col>
          </StyledRow>
        </Container>
      </StyledSectionLegal>
    </StyledFooter>
  );
};

export default FooterSlim;
